import { p as makeInteraction, q as makeCreateInteraction, j as toSerialNumber, o as makeCollection, i as isRemark, s as splitBySquare, t as toInteraction, r as resolveValue, h as toVersion } from './shared/minimark.20470752.mjs';
export { I as Interaction } from './shared/minimark.20470752.mjs';
import { u as upperTrim, t as trim, k as unwrapURI, d as decodeHex } from './shared/minimark.92cd751b.mjs';
import 'nanoid';
import '@polkadot/util';
import '@polkadot/keyring';
import 'slugify';

const createInteraction = (action, objectId, meta) => {
  return makeInteraction(action, "1.0.0", objectId, meta);
};
const createMintInteraction = (action, object) => {
  return makeCreateInteraction(action, "1.0.0", object);
};
const createNFT = (caller, index, collectionId, name, metadata) => {
  const instance = upperTrim(name, true);
  const sn = toSerialNumber(index);
  return {
    name: trim(name),
    instance,
    transferable: 1,
    collection: collectionId,
    sn,
    metadata,
    currentOwner: caller
  };
};
const createCollection = (caller, symbol, name, metadata, max = 0) => {
  return makeCollection(caller, symbol, name, metadata, max);
};
const createMultipleNFT = (max, caller, collectionId, name, metadata, offset = 0, updateName) => {
  return Array(max).fill(null).map((_, i) => createNFT(caller, i + offset, collectionId, updateName ? updateName(name, i) : name, metadata));
};
const createCollectionWithNFT = (max, caller, symbol, name, metadata, updateName) => {
  const collection = createCollection(caller, symbol, name, metadata, max);
  const nfts = createMultipleNFT(max, caller, collection.id, name, metadata, 0, updateName);
  return {
    collection,
    nfts
  };
};

const unwrap = (text) => {
  const decoded = unwrapURI(decodeHex(text));
  if (!isRemark(decoded)) {
    throw new TypeError(`RMRK: Unable to unwrap object ${decoded}`);
  }
  const [, mayInteraction, mayVersion, mayIdOrValue, mayValue] = splitBySquare(decoded);
  const interaction = toInteraction(mayInteraction);
  const value = resolveValue(interaction, mayIdOrValue, mayValue);
  if (!value) {
    throw new TypeError(`RMRK: Unable to unwrap value ${decoded}`);
  }
  return {
    interaction,
    value,
    version: toVersion(mayVersion)
  };
};

const toNFTId = (nft, blockNumber) => {
  const { collection, instance, sn } = nft;
  if (!collection || !instance || !sn) {
    throw new ReferenceError("[APP] toNFTId: invalid nft");
  }
  return `${blockNumber}-${collection}-${instance}-${sn}`;
};

export { createCollection, createCollectionWithNFT, createInteraction, createMintInteraction, createMultipleNFT, createNFT, toNFTId, unwrap as unwrapRemark };
